export enum ExportFormsToCsvOptions {
  CurrentForm = 0,
  All = 1,
}

export enum DisplayAnswersMode {
  AllLatest = 0,
  AllMyLatest = 1,
  ByUser = 2,
}
